import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

export const getWorkOrders = async (params = {}) => {
  const { data } = await apiClient.get("/v1/vehicle-work-orders", { params })
  return data
}

export const getWorkOrder = async (id) => {
  const { data } = await apiClient.get(`/v1/vehicle-work-orders/${id}`)
  return data
}

export const getWorkOrderByVehicle = async (vehicleId) => {
  const { data } = await apiClient.get(`/v1/vehicle-work-orders/by-vehicle/${vehicleId}`)
  return data
}

export const createWorkOrder = async (payload) => {
  const { data } = await apiClient.post("/v1/vehicle-work-orders", payload)
  return data
}

export const updateWorkOrder = async ({ id, ...payload }) => {
  const { data } = await apiClient.put(`/v1/vehicle-work-orders/${id}`, payload)
  return data
}

export const deleteWorkOrder = async (id) => {
  const { data } = await apiClient.delete(`/v1/vehicle-work-orders/${id}`)
  return data
}

export const downloadWorkOrderPdf = ({ id, onStart, onEnd } = {}) =>
  downloadAndOpenFile({
    url: `/v1/vehicle-work-orders/${id}/pdf`,
    mimeType: "application/pdf",
    onStart,
    onEnd,
  })
